import styled from "styled-components";

export const Container = styled.div`
  padding-top: 5em;
`;
export const HeaderImage = styled.div`
  width: 100%;
  height: 10.1875rem;
  background: #bedfff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    height: 8.0625rem;
  }
`;
export const Logo = styled.div`
  width: 4.125em;
  height: 4.125em;
  border-radius: 50%;
  overflow: hidden;
  margin: 2em auto;
`;
// const PaymentSubHeading = styled.h2`
//   color: #3f3f3f;
//   font-size: 0.75rem;
//   font-style: normal;
//   font-weight: 400;
//   line-height: normal;
//   margin-bottom: 0.5em;
// `;
// const Document = styled.div`
//   width: 100%;
//   display: flex;
//   height: 2.25rem;
//   justify-content: space-between;
//   margin: .88em auto;
//   align-items: center;
//   cursor: pointer;
//   border-radius: 0.25rem;
//   border: 1px solid #efefef;
//   background: #fff;
//   padding: 0.6em 0.6em;
//   p {
//     color: #3f3f3f;
//     font-size: 0.875rem;
//     font-style: normal;
//     font-weight: 400;
//     line-height: normal;
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//   }
//   img {
//     width: 1.125rem;
//     height: 1.125rem;
//     flex-shrink: 0;
//   }
// `;
export const ConfirmButton = styled.button`
  width: 100%;
  height: 2.5rem;
  border-radius: 0.5rem;
  background: #000;
  color: #fff;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 2.5em auto;
  text-align: center;
  margin-bottom: 1.56em;
`;
export const Card = styled.div`
  width: 22.375rem;
  border-radius: 0.375rem;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(217, 217, 217, 0.25);
  margin: 0em auto;
  margin-bottom: 4em;
  padding: 2em 2.19em;
  h1 {
    margin: 2em auto;
    margin-top: 0;
    text-align: center;
    color: #3f3f3f;

    font-size: 1.1875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 2em 1.5em;
    width: 100%;
  }
`;
export const SubDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2em auto;
  align-items: baseline;
  h2 {
    color: #3f3f3f;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
export const Note = styled.div`
  margin: 2em auto;
  p {
    color: #3f3f3f;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0.5em 0;
  }
  h2 {
    color: #3f3f3f;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
export const Reward = styled.div`
  margin: 2em auto;
  color: #3f3f3f;

  font-size: 0.875em;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 125%;
  background: #ffedfd;
  padding: 0.2em 2.5em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    left: 50%;
    transform: translateX(-50%);

    width: 120%;
    padding: 0.62em 2em;
  }
  div {
    display: flex;
    justify-content: space-between;
    margin: 0.5em auto;
    align-items: baseline;
    h2 {
      color: #3f3f3f;

      font-size: 0.875em;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
`;
export const Total = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2em auto;
  h2 {
    color: #3f3f3f;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
